"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockRequestErrors = exports.mockClientErrorResponse = void 0;
const _ = require("lodash");
const getInstanceMethodNames_1 = require("../../../helpers/getInstanceMethodNames");
/**
 * The named functions will be replaced with a function that errors.
 * Upon invoking, the original method will be reinstated to help demonstrate
 * how the code recovers.
 * If a count is provided, the original method will be reinstated after that
 * many calls to the method.
 * The erroring function can either throw an Error, or return a rejected
 * promise, depending on the error approach specified.
 */
const mockClientErrorResponse = (client, // HACK unable to use IClient - not used by Next
functionNames, count = 0, errorApproach = "throw") => {
    // replace function with our own
    functionNames.map((name) => {
        let counter = count;
        const originalFunc = _.get(client, name);
        const replaceFunc = () => {
            counter--;
            if (counter <= 0) {
                _.set(client, name, originalFunc);
            }
            // support websockets.
            if (name.toLowerCase().includes("synced")) {
                const metaData = {
                    mockData: new Error(name)
                };
                return metaData;
            }
            switch (errorApproach) {
                case "throw":
                    throw new Error(name);
                case "reject":
                    return new Promise((_resolve, reject) => setTimeout(() => reject("An error occured"), 1000));
            }
        };
        // replace with a function that restores
        _.set(client, name, replaceFunc);
    });
};
exports.mockClientErrorResponse = mockClientErrorResponse;
/**
 * Replace all client methods that perform network requests (or return
 * websocket metadata) with one that will fail COUNT times, after which the
 * original method will be reinstated.
 *
 * Using a real client will cause network requests to fail, whereas using a
 * mock client will cause any client calls to fail (as the mock client doesn't
 * make network requests.)
 */
const mockRequestErrors = (client, // HACK unable to use IClient - not used by Next
count, usingRealClient, errorApproach) => {
    // array of method names in format "moduleName.methodName".
    // e.g. "opsArticles.getOpsArticle".
    const functionNames = [];
    // for each module
    Object.entries(client).forEach(([moduleName, module]) => {
        // exclude methods from these modules.
        if (["httpConnection", "webSocketConnection", "sync", "auth"].includes(moduleName)) {
            return;
        }
        // get list of method names on the current module.
        const moduleMethodNames = (0, getInstanceMethodNames_1.getInstanceMethodNames)(module, Object.prototype);
        // for each method name
        moduleMethodNames
            // get a reference to the actual method
            .map(name => [name, module[name]])
            .forEach(([modulePropertyName, moduleProperty]) => {
            if (typeof moduleProperty !== "function") {
                return;
            }
            // only check if method performs a network request if using real client.
            if (usingRealClient) {
                // get the text of the method.
                const fnText = moduleProperty.toString();
                // this is a rough heuristic.
                // a method probably performs a network request if it contains one of
                // these strings in its function text.
                const functionPerformsNetworkRequest = fnText.includes("fetch") ||
                    fnText.includes("axios") ||
                    fnText.includes("httpConnection") ||
                    // we can also mock websocket methods
                    modulePropertyName.includes("synced");
                // only interested in functions that perform network requests.
                if (!functionPerformsNetworkRequest) {
                    return;
                }
            }
            // Add method name to array
            functionNames.push(`${moduleName}.${modulePropertyName}`);
        });
    });
    // mock all methods in array
    (0, exports.mockClientErrorResponse)(client, functionNames, count, errorApproach);
};
exports.mockRequestErrors = mockRequestErrors;
//# sourceMappingURL=mockClientErrorResponse.js.map